package org.hs_soft.runmynesto.pages.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.css.Resize
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.disabled
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.onFocusIn
import com.varabyte.kobweb.compose.ui.modifiers.onFocusOut
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.onMouseOver
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.resize
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.util.Constants
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.attributes.rows
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.minus
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.TextArea
import org.w3c.dom.HTMLTextAreaElement

@Composable
fun CustomTextArea(
    modifier: Modifier=Modifier,
    fillMaxWidth:Boolean=false,
    fillMaxHeight: Boolean=false,
    value: String,
    label:String,
    placeholder:String?=null,
    isEnable:Boolean=true,
    autoResized:Boolean=false,
    isManualResize:Boolean=true,
    width: CSSSizeValue<CSSUnit.px> = Dimen.mediumTextAreaWidth,
    height: CSSSizeValue<CSSUnit.px> = Dimen.largeTextAreaHeight,
    maxHeight: CSSSizeValue<CSSUnit.px> = (3 * (height.value.toInt())).px,
    onFocusOut: (String) -> Unit,
    onValueChange: (String) -> Unit,
) {
    val inputValue = remember { mutableStateOf(value) }
    val isTextChanged = remember { mutableStateOf(false) }
    val isFocused= remember { mutableStateOf(false) }
    val isHovered= remember { mutableStateOf(false) }


    LaunchedEffect(value) {
        inputValue.value = value
    }
    Box(
        modifier = if(!autoResized) {
            modifier
                .width(width)
                .thenIf(
                    fillMaxWidth,
                    modifier.fillMaxWidth()
                )
                .height(
                    (height.value.toInt() + Dimen.normalPadding.value.toInt()).px
                )
                .thenIf(
                    fillMaxHeight,
                    modifier.fillMaxHeight()
                )
        } else {
            modifier
                .width(width)
                .thenIf(
                    fillMaxWidth,
                    modifier.fillMaxWidth()
                )
        }
    ) {
        if (label.isNotEmpty()){
            SpanText(
                text = label,
                modifier = Modifier
                    .align(Alignment.TopStart)
                    .zIndex(Constants.ZIndex.smallZIndex)
                    .padding(leftRight = Dimen.smallPadding)
                    .backgroundColor(Theme.White.rgb)
                    .margin(
                        left = Dimen.mediumPadding
                    )
                    .color(
                        if (!isEnable) Theme.TextDisabled.rgb
                        else if (isFocused.value) Theme.PrimaryMain.rgb
                        else Theme.TextSecondary.rgb
                    )
                    .fontFamily(FontFamily.Jakarta)
                    .fontSize(FontSizes.semiMediumFontSize)
            )


        }

        TextArea(
            attrs = if (!autoResized) {
                Modifier
                    .margin(topBottom = Dimen.normalPadding)
                    .fillMaxWidth()
                    .height(height)
                    .disabled(!isEnable)
                    .resize(Resize.Vertical)
                    .onMouseOver { if (isEnable) isHovered.value = true }
                    .onMouseLeave { isHovered.value = false }
                    .onFocusIn {
                        if (isEnable) isFocused.value = true
                    }
                    .onFocusOut {
                        isFocused.value = false
                        if (isTextChanged.value) {
                            onFocusOut(inputValue.value)
                            isTextChanged.value = false
                        }
                    }
                    .maxHeight(maxHeight)
                    .border(
                        width = Dimen.smallThickness,
                        color = if (!isEnable) Theme.TextDisabled.rgb
                            else if (isFocused.value) Theme.PrimaryMain.rgb
                            else if (isHovered.value && !isFocused.value)
                                Theme.TextPrimary.rgb
                            else Theme.ActionDisabledBackground.rgb,
                        style = LineStyle.Solid,
                    )
                    .padding(
                        leftRight = if (isFocused.value){
                            (Dimen.mediumPadding.value.toInt()-1).px
                        } else Dimen.mediumPadding,
                        topBottom =if (isFocused.value)
                            (Dimen.smallPadding.value.toInt()-1).px
                        else Dimen.smallPadding,
                    )
                    .fontFamily(FontFamily.Jakarta)
                    .fontSize(FontSizes.mediumFontSize)
                    .borderRadius(r = Dimen.lowBorderRadius)
                    .color(
                        if(isEnable) Theme.TextPrimary.rgb
                        else Theme.Tooltip.rgb
                    )
            } else {
                Modifier
                    .margin(
                        topBottom = Dimen.normalPadding
                    )
                    .fillMaxWidth()
                    .disabled(!isEnable)
                    .onMouseOver { if (isEnable) isHovered.value = true }
                    .onMouseLeave { isHovered.value = false }
                    .onFocusIn {
                        if (isEnable) isFocused.value = true
                    }
                    .onFocusOut {
                        isFocused.value = false
                        if (isTextChanged.value) {
                            onFocusOut(inputValue.value)
                            isTextChanged.value = false
                        }
                    }
                    .maxHeight(maxHeight)
                    .border(
                        width = Dimen.smallThickness,
                        color = if (!isEnable) Theme.TextDisabled.rgb
                            else if (isFocused.value) Theme.PrimaryMain.rgb
                            else if (isHovered.value && !isFocused.value)
                                Theme.TextPrimary.rgb
                            else Theme.InputEnabledBorder.rgb,
                        style = LineStyle.Solid,
                    )
                    .padding(
                        leftRight = if (isFocused.value){
                            (Dimen.mediumPadding.value.toInt()-1).px
                        } else Dimen.mediumPadding,
                        topBottom =if (isFocused.value)
                            (Dimen.smallPadding.value.toInt()-1).px
                        else Dimen.smallPadding,
                    )
                    .fontFamily(FontFamily.Jakarta)
                    .fontSize(FontSizes.mediumFontSize)
                    .borderRadius(r = Dimen.lowBorderRadius)
                    .color(
                        if(isEnable) Theme.TextPrimary.rgb
                        else Theme.Tooltip.rgb
                    )
            }
            .toAttrs {
                if (placeholder != null) {
                    placeholder(placeholder)
                }
                if (autoResized) {
                    rows(1)
                }
                value(inputValue.value)

                onInput { event ->
                    if (isEnable) {
                        val target = event.target as? HTMLTextAreaElement

                        if (autoResized) {
                            target?.style?.height = "auto"
                            val minPx = height.value.toInt()
                            val maxPx = maxHeight.value.toInt()
                            val neededPx = target?.scrollHeight ?: minPx
                            target?.style?.height = "${minOf(maxPx, maxOf(minPx, neededPx))}px"
                        }

                        inputValue.value = target?.value ?: ""
                        isTextChanged.value = true

                        onValueChange(inputValue.value)
                    }
                }

                style {
                    if (autoResized) {
                        property("min-height", "${height.value}")
                        property("height", "${height.value}")
                        property("box-sizing", "border-box")
                    }
                    if (!isManualResize) {
                        property("resize", "none")
                    }
                    property("outline", "none")

                    property("border-color",
                        if (!isEnable) Theme.TextDisabled.hex
                        else if (isFocused.value) Theme.PrimaryMain.hex
                        else if(isHovered.value) Theme.TextPrimary.hex
                        else Theme.InputEnabledBorder.hex
                    )
                    property("border-width",
                        if (isFocused.value) Dimen.mediumThickness.toString()
                        else Dimen.smallThickness.toString()
                    )
                }
            }
        )
    }
}